import { render, staticRenderFns } from "./DiscGolf.vue?vue&type=template&id=c2d92530&scoped=true&"
import script from "./DiscGolf.vue?vue&type=script&lang=js&"
export * from "./DiscGolf.vue?vue&type=script&lang=js&"
import style0 from "./DiscGolf.vue?vue&type=style&index=0&id=c2d92530&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d92530",
  null
  
)

export default component.exports